export default "__VITE_ASSET__D5Lv7Ihf__"